import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import {
  CreateContactTypeModel,
  DeleteContactTypeModel,
  EditContactTypeModel,
  SearchContactTypeModel,
} from '../../../models/contact-type.model'
import { ResponseRequestModel } from '../../../models/response.model'

@Injectable({
  providedIn: 'root',
})
export class ProfileTypeService {
  private baseUrl = environment.baseUrl
  private resource: string = 'usuario/perfil'

  constructor(private httpClient: HttpClient) {}

  public createContactType(
    model: CreateContactTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editContactType(
    model: EditContactTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.put<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/update`,
      model,
    )
  }

  public deleteContactType(
    model: DeleteContactTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public listPagedContactType(
    page?: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/list`,
    )
  }

  public listContactType(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public getContactTypebyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedContactType(
    page: number,
    rows: number = 15,
    model: SearchContactTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
